import React, { Component } from 'react'

import Home from './pages/Home'
import Listing from './pages/Listing'
import ExtraPageElements from './pages/ExtraPageElements'

import {BrowserRouter, Routes, Route} from 'react-router-dom'
import Footer from './components/Footer'


function App()
{
  const hostname = window.location.hostname;

    if (hostname === "service.pingingo.com")
    {
      return (
      <div>
          <BrowserRouter>
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/:lang' element={<Home />} />
            </Routes>
          </BrowserRouter>
      </div>
      )
    }
    else if (hostname === "listing.pingingo.com")
    {
      return (
      <div>
          <BrowserRouter>
            <Routes>
              <Route path='/' element={<Listing />} />
              <Route path='/:lang' element={<Listing />} />
            </Routes>
          </BrowserRouter>
      </div>
      )
    }
    else
    {
      return (
      <div>
          <BrowserRouter>
            <Routes>
              <Route path='/' element={<Home/>} />
              <Route path='/listing' element={<Listing/>} />
              <Route path='/extrapageelement' element={<ExtraPageElements/>} />
            </Routes>
          </BrowserRouter>
      </div>
      )
    }
}

export default App  